const STICKERS = [
  {
    id: "crest",
    file: "/stickers/crest.png",
    label: "The Crest",
    note: "Helmet · Water bottle · Notebook",
    rotate: "-rotate-3",
  },
  {
    id: "wordmark",
    file: "/stickers/wordmark.png",
    label: "The Wordmark",
    note: "Locker · Stick shaft · Laptop",
    rotate: "rotate-2",
  },
  {
    id: "monogram",
    file: "/stickers/monogram.png",
    label: "Tricolor Monogram",
    note: "Anywhere small. Anywhere everywhere.",
    rotate: "-rotate-1",
  },
  {
    id: "slogan",
    file: "/stickers/slogan.png",
    label: "Speak Softly · Carry Big",
    note: "Parents' bumper · Coach's clipboard",
    rotate: "rotate-3",
  },
];

export default function Stickers() {
  return (
    <section
      id="stickers"
      data-testid="stickers-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 border-t border-neutral-900 overflow-hidden"
    >
      {/* Soft red glow on the left */}
      <div
        aria-hidden
        className="absolute -left-40 top-1/2 -translate-y-1/2 w-[480px] h-[480px] rounded-full bg-[#e11d2a]/10 blur-[120px] pointer-events-none"
      />
      {/* Soft navy glow on the right */}
      <div
        aria-hidden
        className="absolute -right-40 top-1/3 w-[480px] h-[480px] rounded-full bg-[#1b2f5c]/40 blur-[120px] pointer-events-none"
      />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20 items-end">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-[#e11d2a] mb-5">
              <span className="inline-block w-8 h-px bg-[#e11d2a]" />
              <span>The Sticker Pack · Limited</span>
            </div>
            <h2 className="font-anton uppercase text-5xl sm:text-6xl md:text-7xl leading-[0.9] tracking-tight">
              Slap 'em <br />
              <span className="text-[#e11d2a]">everywhere.</span>
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-neutral-400 text-sm md:text-base leading-relaxed">
              Heavy-duty glossy vinyl die-cuts. Stick 'em on helmets, water
              bottles, lockers, laptops, your sister's homework — wherever the
              energy needs to land.
            </p>
          </div>
        </div>

        {/* Sticker grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {STICKERS.map((s, i) => (
            <article
              key={s.id}
              data-testid={`sticker-${s.id}`}
              className={`group relative bg-[#0f0f0f] border border-neutral-900 hover:border-[#e11d2a]/40 transition-all p-6 md:p-8`}
            >
              {/* Subtle grid backdrop */}
              <div
                aria-hidden
                className="absolute inset-0 opacity-[0.04] pointer-events-none"
                style={{
                  backgroundImage:
                    "repeating-linear-gradient(0deg, #fff 0 1px, transparent 1px 24px), repeating-linear-gradient(90deg, #fff 0 1px, transparent 1px 24px)",
                }}
              />

              <div className="aspect-square flex items-center justify-center relative">
                <img
                  src={s.file}
                  alt={s.label}
                  draggable={false}
                  className={`max-w-[90%] max-h-[90%] object-contain transform ${s.rotate} group-hover:rotate-0 group-hover:scale-[1.05] transition-transform duration-500 ease-out drop-shadow-[0_12px_24px_rgba(0,0,0,0.55)]`}
                />
              </div>

              <div className="relative mt-4 pt-4 border-t border-neutral-900">
                <div className="font-anton text-lg uppercase tracking-tight">
                  {s.label}
                </div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 mt-1">
                  {s.note}
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* CTA strip */}
        <div className="mt-12 md:mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-neutral-900 pt-8">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-1">
              Sticker Pack · Set of 4
            </div>
            <div className="flex items-baseline gap-3">
              <span className="font-anton text-4xl md:text-5xl tracking-tight">
                $12
              </span>
              <span className="text-xs tracking-[0.2em] uppercase text-neutral-500">
                or free with any jersey order
              </span>
            </div>
          </div>
          <a
            href="#reserve"
            data-testid="stickers-cta-btn"
            className="group inline-flex items-center gap-3 bg-[#e11d2a] hover:bg-[#ff3340] text-white font-bold uppercase tracking-wide text-sm px-6 py-4 transition-all"
          >
            Add to Reservation
            <span className="inline-block group-hover:translate-x-0.5 transition-transform">
              →
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
